export const TimePickerMeridians = {
    AM: 'AM',
    PM: 'PM',
};
